import { Colors, Fonts } from '../../../shared/theme/';
import React from 'react';

export default {
  defaultContent: {
    backgroundColor: Colors.white,
    padding: 20,
  } as React.CSSProperties,
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '16px',
    height: '56px'
  } as React.CSSProperties,
  headerText: {
    fontSize: 24
  } as React.CSSProperties,
  icon: {
    width: 16,
    height: 16
  } as React.CSSProperties,
  tableWrapper: {
    backgroundColor: Colors.white,
    padding: 20
  } as React.CSSProperties,
  vatAddressNameText: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.fakeBlack,
    paddingLeft: '75px'
  },
  vatAddressTaxIdText: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.fakeBlack,
    paddingLeft: '20px'
  },
};
